<!--
this.compData?.container?.key ==> {{ compData?.container?.key }}
this.compData?.container?.apiURL ==> {{ compData?.container?.apiURL }}
this.dynamicContainers?.length ==> {{ dynamicContainers?.length }}
-->


<!--<div>
inside check observable

<div *ngIf="(dynamicContainersObservable | async) as containers">
  container is {{ containers | json }}
</div>
</div>-->

<!--minHeight ==> {{ minHeight }}
compData?.container?.skeletonHeight ==> {{ compData?.container?.skeletonHeight }}-->


<div [ngStyle]="{ 'minHeight': minHeight + 'px' }" class="dynamic-card">
  @for (dynamicContainer of dynamicContainers; track dynamicContainer; let last = $last; let first = $first; let index = $index) {
    <div class="dynamic-container-shell"
         [ngStyle]="{ 'minHeight': (dynamicContainers?.length > 0 ? dynamicContainer?.skeletonHeight + 'px' : minHeight + 'px') }"
    >
      @if (dynamicContainer?.component) {
        @if (((dynamicContainer?.component | b2bDynamicLoaderPipe : dynamicContainer?.key) | async); as nestedChildComponent; ) {
          <!--<div (dismissEvent)="onSelectEvent($event)" [appLoader]="nestedChildComponent"
             [compData]="{
                  container: dynamicContainer,
                  last: last,
                  first: first,
                  index: index
              }" appB2bDynamicLoader
          >
        </div>-->
          <ng-container *ngComponentOutlet="nestedChildComponent; inputs: {
          compData: {
                  container: dynamicContainer,
                  last: last,
                  first: first,
                  index: index
              }
          }"/>
        }
      }
    </div>
  }

  @if (showLoader) {
    <div class="ld-sec">
      <div class="flex-container ion-align-items-center ion-justify-content-center loader-wrap">
        <span class="loader"></span>
      </div>
      <!--<div class="skeleton-box"></div>-->
      <!--<div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>-->
    </div>
  }

</div>

<!--<div #dynamicCardContainer [ngClass]="{ 'not-loaded': !isLoaded }">
<ng-template (loadedEvent)="onLoaded()" [appB2bInViewPort]="dynamicCardContainer">
  &lt;!&ndash;<div *ngIf="showLoader" class="main-loader">
  <div>
    &lt;!&ndash;<app-b2b-spinner></app-b2b-spinner>&ndash;&gt;
    &lt;!&ndash;<ion-thumbnail slot="start" style="width: 100%;min-height: 150px;border-radius: 6px;">
    <ion-skeleton-text [animated]="true"
    style="width: 100%;min-height: 150px;border-radius: 6px;"></ion-skeleton-text>
  </ion-thumbnail>&ndash;&gt;
  &lt;!&ndash;<ion-spinner name="crescent"></ion-spinner>&ndash;&gt;
</div>
</div>&ndash;&gt;


<div [ngStyle]="{ 'minHeight': minHeight + 'px' }">
  &lt;!&ndash;<div class="main-loader" *ngIf="showLoader">
  To Do Loader
</div>&ndash;&gt;

<div class="dynamic-container-shell"
  [ngStyle]="{ 'minHeight': (dynamicContainers?.length > 0 ? dynamicContainer?.skeletonHeight + 'px' : compData?.container?.skeletonHeight + 'px') }"
  *ngFor="let dynamicContainer of dynamicContainers; let last = last; let first = first; let index = index;"
  [@enterAnimationComponent]="true">

  <ng-container *ngIf="dynamicContainer?.component">
    <ng-container
      *ngIf="((dynamicContainer?.component | b2bDynamicLoaderPipe) | async) as nestedChildComponent;">
      <div (dismissEvent)="onSelectEvent($event)" [appLoader]="nestedChildComponent"
                 [compData]="{
                  container: dynamicContainer,
                  last: last,
                  first: first,
                  index: index
              }" appB2bDynamicLoader
        >
      </div>
    </ng-container>
  </ng-container>
</div>
</div>
</ng-template>

&lt;!&ndash;<div *appB2bInViewPort="dynamicCardContainer">
<ng-container *ngFor="let dynamicContainer of dynamicContainers">
  <ng-container *ngIf="dynamicContainer?.component">
    <ng-container
      *ngIf="((dynamicContainer?.component | b2bDynamicLoaderPipe) | async) as nestedChildComponent">
      <div (dismissEvent)="onSelectEvent($event)" [appLoader]="nestedChildComponent"
              [compData]="{
                  container: dynamicContainer
              }"
        appB2bDynamicLoader
        >
      </div>
    </ng-container>
  </ng-container>
</ng-container>
</div>&ndash;&gt;
</div>-->

@if (errorContainers?.length > 0) {
  @for (errorContainer of errorContainers; track errorContainer) {
    @if (((errorContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
      <div [appLoader]="component" [compData]="{
          container: errorContainer
       }" appB2bDynamicLoader class="error-container">
      </div>
    }
  }
}

<!--<ng-template #skeletonTemplate>
<div class="main-loader">
  &lt;!&ndash;<ion-spinner name="crescent"></ion-spinner>&ndash;&gt;
  &lt;!&ndash;<div>
  <ion-thumbnail slot="start" style="width: 100%;min-height: 150px;border-radius: 6px;">
    <ion-skeleton-text [animated]="true"
    style="width: 100%;min-height: 150px;border-radius: 6px;"></ion-skeleton-text>
  </ion-thumbnail>
</div>&ndash;&gt;
</div>
</ng-template>-->
